import { render, staticRenderFns } from "./MagSubmenuItemGroups.vue?vue&type=template&id=25faab4e&scoped=true"
import script from "./MagSubmenuItemGroups.vue?vue&type=script&lang=js"
export * from "./MagSubmenuItemGroups.vue?vue&type=script&lang=js"
import style0 from "./MagSubmenuItemGroups.vue?vue&type=style&index=0&id=25faab4e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25faab4e",
  null
  
)

export default component.exports